import React, { useState } from "react";
import { useAuth, API_URL } from "../AuthContext";

export default function Login({ onClose, onSwitchToRegister, onFeedback, onSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("login"); // login | forgot | sent

  const sendReset = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await fetch(`${API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || "Не удалось отправить письмо. Попробуйте позже.");
      setMode("sent");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || "Ошибка входа");
      login(data.access_token, data.user);
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{mode === "login" ? "Вход в портал" : "Восстановление пароля"}</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div style={{ background: "#e6f6f7", color: "#007c84", borderRadius: 8, padding: "8px 12px", fontSize: "0.82rem", marginBottom: 12, textAlign: "center" }}>
          Портал в режиме бета-тестирования — если что-то работает не так, пожалуйста,{" "}
          <button type="button" onClick={onFeedback} style={{ background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", textDecoration: "underline", cursor: "pointer" }}>сообщите нам об этом</button>
        </div>

        {mode === "login" && (
          <>
            <form onSubmit={submit} className="auth-form">
              {error && <div className="auth-error">{error}</div>}
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="doctor@mail.ru" required className="auth-input" />
              <label>Пароль</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" required className="auth-input" />
              <button type="submit" disabled={loading} className="auth-submit-btn">
                {loading ? "Входим…" : "Войти"}
              </button>
            </form>
            <p className="auth-switch-text">
              <button type="button" className="btn-link" onClick={() => { setError(""); setMode("forgot"); }}>
                Забыли пароль?
              </button>
            </p>
            <p className="auth-switch-text">
              Нет аккаунта?{" "}
              <button className="btn-link" onClick={onSwitchToRegister}>
                Зарегистрироваться
              </button>
            </p>
          </>
        )}
        {mode === "forgot" && (
          <>
            <form onSubmit={sendReset} className="auth-form">
              <p style={{ fontSize: "0.9rem", margin: "0 0 8px" }}>Укажите адрес, с которым вы регистрировались. Мы отправим ссылку для создания нового пароля.</p>
              {error && <div className="auth-error">{error}</div>}
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="doctor@mail.ru" required className="auth-input" autoFocus />
              <button type="submit" disabled={loading} className="auth-submit-btn">
                {loading ? "Отправляем…" : "Отправить ссылку"}
              </button>
            </form>
            <p className="auth-switch-text">
              <button type="button" className="btn-link" onClick={() => { setError(""); setMode("login"); }}>
                Вернуться ко входу
              </button>
            </p>
          </>
        )}
        {mode === "sent" && (
          <div className="auth-form" role="status">
            <p style={{ fontSize: "0.95rem", margin: "0 0 8px" }}>
              Если аккаунт с адресом <strong>{email}</strong> существует, мы отправили на него письмо со ссылкой. Она действует 1 час.
            </p>
            <p style={{ fontSize: "0.85rem", color: "#666", margin: "0 0 12px" }}>Письма нет? Проверьте папку «Спам» и убедитесь, что адрес указан без ошибок.</p>
            <button type="button" className="auth-submit-btn" onClick={() => setMode("login")}>Вернуться ко входу</button>
          </div>
        )}
      </div>
    </div>
  );
}
